export default __webpack_public_path__ + "static/media/check.98bcb8cb.svg";